import React from 'react';
import PricingPage from './PricingPage';

// Country-locked pricing page for UK Meta Ads — same PricingPage but the
// region context is forced to `uk` (GBP prices), the currency toggle is
// hidden, and all register CTAs include `?region=uk`.
const UkPricingPage = () => <PricingPage lockedRegion="uk" />;

export default UkPricingPage;
